var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getJson, postJson, putJson, deleteJson, withDone, withValidate } from '@rad/utility/http';
// ── Dashboards ──
export const getDashboards = (tenantId, p) => {
    const segment = tenantId !== null && tenantId !== void 0 ? tenantId : 'system';
    return withDone(getJson(`/api/analytics/tenant/${segment}`, p))();
};
export const getDashboard = (id) => withDone(getJson(`/api/analytics/${id}`))();
export const getHomeDashboard = (tenantId) => {
    const segment = tenantId !== null && tenantId !== void 0 ? tenantId : 'system';
    return withDone(getJson(`/api/analytics/tenant/${segment}/home`))();
};
export const createDashboard = (tenantId, body) => {
    const segment = tenantId !== null && tenantId !== void 0 ? tenantId : 'system';
    return withDone(withValidate(postJson(`/api/analytics/tenant/${segment}`, body)))();
};
export const updateDashboard = (id, body) => withDone(putJson(`/api/analytics/${id}`, body))();
export const deleteDashboard = (id) => withDone(deleteJson(`/api/analytics/${id}`))();
export const saveDashboardLayout = (id, layoutConfig) => withDone(putJson(`/api/analytics/${id}/layout`, { layoutConfig }))();
export const saveDashboardFilters = (id, globalFilters) => withDone(putJson(`/api/analytics/${id}/filters`, { globalFilters }))();
// ── Widgets ──
export const getWidgets = (tenantId, p) => {
    const segment = tenantId !== null && tenantId !== void 0 ? tenantId : 'system';
    return withDone(getJson(`/api/analytics/tenant/${segment}/widgets`, p))();
};
export const createWidget = (dashboardId, body) => withDone(withValidate(postJson(`/api/analytics/${dashboardId}/widgets`, body)))();
export const createStandaloneWidget = (tenantId, body) => {
    const segment = tenantId !== null && tenantId !== void 0 ? tenantId : 'system';
    return withDone(withValidate(postJson(`/api/analytics/tenant/${segment}/widgets`, body)))();
};
export const updateWidget = (id, body) => withDone(putJson(`/api/analytics/widgets/${id}`, body))();
export const deleteWidget = (id) => withDone(deleteJson(`/api/analytics/widgets/${id}`))();
export const executeWidget = (id, filters) => {
    if (filters && filters.length > 0) {
        return withDone(postJson(`/api/analytics/widgets/${id}/exec`, { filters }))();
    }
    return withDone(getJson(`/api/analytics/widgets/${id}/exec`))();
};
// The server's verdict on a query config, always a 200. A request that fails rejects, so the editor
// can go on without one.
export const validateWidget = (queryConfig) => withDone(postJson('/api/analytics/widgets/validate', { queryConfig }))();
// No rows, without an error shown: a saved query that no longer runs answers 400, a widget that is
// gone 404.
const withNoRows = (f) => (c, m) => f(c, (m2) => m(Object.assign(Object.assign({}, m2), { 400: () => __awaiter(void 0, void 0, void 0, function* () { return null; }), 404: () => __awaiter(void 0, void 0, void 0, function* () { return null; }) })));
// A saved widget's rows, read for their columns; null when it has none to give, and any other failure
// rejects.
export const sampleWidget = (id) => withDone(withNoRows(getJson(`/api/analytics/widgets/${id}/exec`)))();
// ── Dashboard pages ──
export const getPages = (dashboardId) => withDone(getJson(`/api/analytics/${dashboardId}/pages`))();
export const createPage = (dashboardId, title) => withDone(withValidate(postJson(`/api/analytics/${dashboardId}/pages`, { title })))();
export const updatePage = (pageId, title) => withDone(putJson(`/api/analytics/pages/${pageId}`, { title }))();
export const deletePage = (pageId) => withDone(deleteJson(`/api/analytics/pages/${pageId}`))();
export const reorderPages = (pageIds) => withDone(postJson(`/api/analytics/pages/reorder`, { pageIds: pageIds.join(',') }))();
export const assignWidgetPage = (widgetId, pageId) => withDone(putJson(`/api/analytics/widgets/${widgetId}/page`, { pageId: pageId || '' }))();
// ── Drill-through ──
export const drillWidget = (widgetId, filters, page, pageSize) => {
    const params = new URLSearchParams();
    if (page)
        params.set('page', String(page));
    if (pageSize)
        params.set('pageSize', String(pageSize));
    const qs = params.toString() ? `?${params.toString()}` : '';
    if (filters && filters.length > 0) {
        return withDone(postJson(`/api/analytics/widgets/${widgetId}/drill${qs}`, { filters }))();
    }
    return withDone(postJson(`/api/analytics/widgets/${widgetId}/drill${qs}`, {}))();
};
// ── Widget History ──
export const getWidgetHistory = (widgetId) => withDone(getJson(`/api/analytics/widgets/${widgetId}/history`))();
export const restoreWidgetVersion = (widgetId, eventId) => withDone(postJson(`/api/analytics/widgets/${widgetId}/history/${eventId}/restore`, {}))();
// ── Schema introspection ──
export const getTableSchema = () => withDone(getJson(`/api/analytics/schema/tables`))();
export const getTableColumns = (tableName) => withDone(getJson(`/api/analytics/schema/tables/${tableName}/columns`))();
export const getDistinctValues = (tableName, columnName) => withDone(getJson(`/api/analytics/schema/distinct/${tableName}/${columnName}`))();
